import Template from "../templates/RoleDetail/RoleDetailTemplate";

const RoleDetail = () => <Template />;

export default RoleDetail;
